import { Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CURRENCY_REGEX } from "../../../../utils/currencyUtils";

import type { TransportationParams } from "../../../../utils/Types";
import useBudgetHelpers from "../../../../utils/useBudgetHelpers/useBudgetHelpers";
import useNavigateHelpers from "../../../../utils/useNavigateHelpers/useNavigateHelpers";
import usePostIntent from "../../../../utils/usePostIntent/usePostIntent";
import FormNavButtons from "../../../Common/FormNavButtons/FormNavButtons";
import FormTitle from "../../../Common/FormTitle/FormTitle";
import TextFieldGroup from "../../../Common/TextFieldGroup/TextFieldGroup";

export function Transportation() {
	const { t: global } = useTranslation("global");
	const { t } = useTranslation("expenses");

	const { postFormData, postStatus } = usePostIntent();
	const { generateDefaultValues } = useBudgetHelpers();

	const {
		handleSubmit,
		control,
		formState: { isDirty },
	} = useForm<TransportationParams>({
		defaultValues: generateDefaultValues<TransportationParams>([
			"Bus Fare",
			"Other Transportation Fees",
		]),
	});

	const { navigateNextPrompt } = useNavigateHelpers();

	const submitForm = (data: TransportationParams) => {
		if (isDirty) {
			const CATEGORY = "Transportation";
			postFormData(data, CATEGORY).then(() => {
				postStatus();
				navigateNextPrompt();
			});
		} else {
			postStatus();
			navigateNextPrompt();
		}
	};

	return (
		<>
			<FormTitle faIcon={["fas", "bus"]}>
				{t("transportation.formTitle")}
			</FormTitle>
			<p className="text-navy-blue italic text-small">{global("monthly")}</p>
			<Form onSubmit={handleSubmit(submitForm)} noValidate>
				<Row>
					<Form.Group>
						<TextFieldGroup
							rules={{
								pattern: {
									value: CURRENCY_REGEX,
									message: global("rules.dollarAmount"),
								},
								max: {
									value: 10000,
									message: global("rules.max", { amount: 10000 }),
								},
								min: {
									value: 0,
									message: global("rules.min"),
								},
							}}
							label={t("transportation.bus.label")}
							prefix="$"
							className="field-xs"
							name="Bus Fare"
							type="number"
							control={control}
						/>
					</Form.Group>
				</Row>
				<p className="fw-light text-navy-blue mt-3 mx-auto">
					{t("transportation.description")}
				</p>
				<Row>
					<Form.Group>
						<TextFieldGroup
							rules={{
								pattern: {
									value: CURRENCY_REGEX,
									message: global("rules.dollarAmount"),
								},
								max: {
									value: 10000,
									message: global("rules.max", { amount: 10000 }),
								},
								min: {
									value: 0,
									message: global("rules.min"),
								},
							}}
							label={t("transportation.otherFares.label")}
							prefix="$"
							className="field-xs"
							name="Other Transportation Fees"
							type="number"
							control={control}
						/>
					</Form.Group>
				</Row>
				<FormNavButtons />
			</Form>
		</>
	);
}
